import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, MessageCircle, ShoppingBag, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { LOGO_URL, openWhatsApp, quickMessage } from "../lib/site";

const NAV = [
  { to: "/", label: "Home", exact: true },
  { to: "/shop", label: "Shop All" },
  { to: "/shop/moringa-powder", label: "Moringa Powder" },
  { to: "/shop/fruit-chips", label: "Dehydrated Fruits" },
  { to: "/shop/vegetable-chips", label: "Dehydrated Vegetables" },
  { to: "/shop/fruit-vegetable-powders", label: "Fruit & Vegetable Powders" },
  { to: "/shop/moringa-sweets", label: "Moringa Sweets" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { count, setOpen: setCartOpen } = useCart();

  return (
    <motion.header className="site-header"
      initial={{ y: -80, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 0.61, 0.36, 1] }}>
      <Link to="/" className="brand" data-testid="brand-logo" aria-label="Bhoomiza Organics home">
        <img src={LOGO_URL} alt="Bhoomiza Organics" />
      </Link>
      <nav className={open ? "desktop-nav is-open" : "desktop-nav"} aria-label="Main navigation">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.exact}
            className={({ isActive }) => (isActive ? "nav-link is-active" : "nav-link")}
            onClick={() => setOpen(false)}
            data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and")}`}>
            {n.label}
          </NavLink>
        ))}
      </nav>
      <div className="header-actions">
        <button className="header-cart" onClick={() => setCartOpen(true)} data-testid="header-cart-button" aria-label={`Open cart with ${count} items`}>
          <ShoppingBag size={16} />
          <span>Cart</span>
          {count > 0 && <span className="cart-badge" data-testid="cart-count-badge">{count}</span>}
        </button>
        <button className="header-order" onClick={() => openWhatsApp(quickMessage)} data-testid="header-whatsapp-button">
          <MessageCircle size={16} /> WhatsApp
        </button>
      </div>
      <button className="mobile-menu-button" onClick={() => setOpen(!open)} data-testid="mobile-menu-button" aria-label="Toggle menu" aria-expanded={open}>
        {open ? <X /> : <Menu />}
      </button>
    </motion.header>
  );
}
